<template lang="html">
  <div class="modal
  d-flex justify-content-center align-items-center">
    <div class="w-100">
      <div class="py-3 w-100">
        <div class="views-label" v-if="type === 'pano'">
          <span>
            {{ plan.name }} views.
            <br/>
            Pan left or right to see more.
          </span>
        </div>
        <div class="views-label" v-else>
          <span class="dynamic-label">
            {{ plan.name }}
          </span>
          views on floor
          <span class="dynamic-label">
            {{ floor }}
          </span>
        </div>
        <div id="panorama" :class="{'active': loaded}" v-show="type === 'pano'">
          <div id="panorama-canvas" class="m-auto"
          :style="{'background-image': 'url(' + panoUrl + ')'}"></div>
        </div>
        <div id="view-gallery" v-show="type !== 'pano'">
          <view-slides :slides="viewsArr" ref="viewSlides" />
        </div>
      </div>
      <div class="py-2">
        <button @click="$close()"
        class="btn btn-action m-auto">
          <i class="fal fa-times"></i>
          <span>CLOSE</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* global Impetus */
import { mapState, mapGetters } from 'vuex';
import ViewSlides from '@/components/ViewSlides';

// DIALOGUE PARAMS: floor, exposure, type, plan

export default {
  props: {
    floor: {
      type: String,
      default: 0
    },
    exposure: {
      type: String,
      default: 'n'
    },
    type: {
      type: String,
      default: 'A'
    },
    plan: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      impetus: null,
      loaded: false,
      widthLabel: '',
      index: 0
    };
  },
  computed: {
    ...mapState({
      viewList: state => state.floorplans.views.viewList,
      assetsUrl: state => state.project.assetsUrl
    }),
    ...mapGetters({
      deviceMd: 'ui/deviceMd'
    }),
    panoUrl() {
      return this.viewList.find(
        view => view.viewType === 'pano'
      ).images[0].src;
    },
    viewsArr() {
      let targetFloor = parseInt(this.floor, 10);
      const targViewArr = [];

      // Hardcoded exceptions for floor 10, UNIT 1F, 2W, 2X, 3C
      if (this.plan.name.indexOf('1F Level 10 ') > -1 ||
        this.plan.name === '2W Level 10' ||
        this.plan.name === '2X Level 10' ||
        this.plan.name === '3C Level 10') {
        if (parseInt(this.floor, 10) === 10) {
          targetFloor = 9;
        }
      }
      const viewSet = this.viewList.find(view => parseInt(view.floor, 10) === targetFloor && view.viewType === this.type);
      if (viewSet) {
        return viewSet.images || [];
      }
      return [];
    },
    // singleUrl() {
    //   if (this.viewsArr.length > 0) {
    //     return this.assetsUrl + this.viewsArr[this.index].url
    //   }
    //   return '';
    // }
  },
  methods: {
    initPanoramicImage() {
      const canvas = document.getElementById('panorama-canvas');
      const scrollLength = -((this.viewImage.width / this.viewImage.height) * canvas.clientHeight); // -3400
      // const boundXmin = scrollLength + canvas.clientWidth; // -2550
      if (this.impetus) {
        this.impetus.destroy();
      }

      const initialY = 0;
      let initialX = 0;
      let viewMinX = 0;
      let viewMaxX = 0;
      // let viewMultiplier = 1;
      // let quarterWidth = this.viewImage.width / 4;
      if (!this.deviceMd) {
        // quarterWidth = this.viewImage.width / 5;
      }

      initialX = 0;

      // if (this.exposure.includes('n')) {
      //   initialX = 0;
      //   if (this.exposure.includes('w')) {
      //     initialX += quarterWidth;
      //     viewMultiplier = 2;
      //   } else if (this.exposure.includes('e')) {
      //     viewMultiplier = 2;
      //   }
      // } else if (this.exposure.includes('s')) {
      //   initialX = scrollLength / 2;
      //   if (this.exposure.includes('w')) {
      //     viewMultiplier = 2;
      //   } else if (this.exposure.includes('e')) {
      //     viewMultiplier = 2;
      //     initialX += quarterWidth;
      //   }
      // } else if (this.exposure.includes('e')) {
      //   initialX = scrollLength / 4;
      // } else if (this.exposure.includes('w')) {
      //   initialX = boundXmin;
      // }

      viewMinX = initialX;
      // viewMaxX = viewMinX - (quarterWidth * viewMultiplier) + canvas.clientWidth; // -2550
      viewMaxX = scrollLength + canvas.clientWidth;

      console.log(scrollLength, this.viewImage.width, canvas.clientWidth, viewMinX, viewMaxX);

      this.impetus = new Impetus({
        source: canvas,
        friction: 0.96,
        multiplier: 1.2,
        bounce: false,
        boundX: [viewMaxX, viewMinX],
        boundY: [0, 0],
        initialValues: [initialX, initialY],
        update: (x) => {
          canvas.style.backgroundPosition = `${x}px 0px`;
          console.log(x);
        }
      });

      // this.impetus.pause();

      this.loaded = true;
    }
  },
  created() {
    this.viewImage = new Image();
    this.viewImage.onload = this.initPanoramicImage;

    if (this.type === 'pano') {
      console.log('pano detected');
      this.viewImage.src = this.panoUrl;
    }
  },
  mounted() {
    const canvas = document.getElementById('panorama-canvas');
    this.widthLabel = canvas.clientWidth;
  },
  beforeDestroy() {
    if (this.impetus) {
      this.impetus.destroy();
    }
  },
  components: {
    'view-slides': ViewSlides
  }
};
</script>

<style lang="scss" scoped>
.modal {
  background-color: hsla(0, 0, 0, 0.9);
}

.views-label {
  color: white;
}

.dynamic-label {
  font-size: 1.4rem;
  font-family: Scandia-Regular, sans-serif;
}

#panorama {
  width: 100%;
}

#panorama-canvas {
  background-position: center center;
  background-size: auto 100%;
  height: 700px;
  width: 100%;
  max-width: 1450px;
  border-radius: .25rem!important;

  @media screen and (max-width: $breakpoint-medium) {
    height: 600px;
  }
}

#view-gallery {
  min-height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/ViewsDialog.vue